import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../features/login/loginSlice";
import companyTokenReducer from "../features/login/companyTokenSlice";
import simActivationReducer from "../features/simActivation/simActivationSliceList";
import simActionReducer from "../features/simActivation/simActionSlice";
import whiteListDeviceReducer from "../features/dashboard/whiteListDeviceSlice";
import kycReducer from "../features/kycMaster/kycMasterSlice"; // Ensure path is correct
import addVendorReducer from "../features/vendor/addVendorSlice";
import vendorReducer from "../features/vendor/vendorListSlice";
import vendorDropdownReducer from "../features/vendor/vendorDropdownSlice";
import vendorStatusReducer from "../features/vendor/updateVendorStatusSlice";
import exportAllVendorReducer from "../features/vendor/exportAllVendorSlice";

import customerManagementSlice from "../features/customerManagement/customerManagementSlice"
import planManagementSlice from '../features/planManagement/PlanManagementSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  companyToken: companyTokenReducer,
  simActivation: simActivationReducer,
  actionList: simActionReducer,
  whiteListDevice: whiteListDeviceReducer,
  kyc: kycReducer,
  addVendor: addVendorReducer,
  vendor: vendorReducer,
  vendorDropdowns: vendorDropdownReducer,
  vendorStatus: vendorStatusReducer,
  exportAllVendor: exportAllVendorReducer,
  customerManagement : customerManagementSlice,
  planManagement : planManagementSlice,
});

export default rootReducer;
